// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface PlatformHeaderProps {
  platforms: unknown[];
  filterPlatform?: string;
  handleFilterPlatform: (e: unknown) => void;
}

function PlatformHeader({ platforms, filterPlatform, handleFilterPlatform }: PlatformHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="bulk-grid-game-name-th">
      <span className="mb-2">{t('Platform')}</span>
      <select
        className="form-control "
        value={filterPlatform || ''}
        onChange={handleFilterPlatform}
      >
        <option value="">{t('All')}</option>
        {platforms
          ? [...platforms]
            ?.sort((a: any, b: any) => a.name.localeCompare(b.name))
            .map((x: any) => (
              <option key={x.id} value={x.id}>
                {x.name}
              </option>
            ))
          : ''}
      </select>
    </div>
  );
}

export default PlatformHeader;
